package link.erpango.quip.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.DropdownMenuItem
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.ExposedDropdownMenuBox
import androidx.compose.material.ExposedDropdownMenuDefaults
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.material.Scaffold
import androidx.compose.material.Snackbar
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Done
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import link.erpango.quip.domain.entities.DSparePart
import link.erpango.quip.domain.entities.DSparePartCatalog
import link.erpango.quip.domain.entities.DSparePartType
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.ui.components.QuipDropdownTextField
import link.erpango.quip.ui.components.QuipSectionHeader
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.ui.components.QuipTransparentHeader
import org.jetbrains.compose.resources.stringResource
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.foundation.layout.width
import link.erpango.quip.QuipConstants
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.add_spare_part
import quip.composeapp.generated.resources.additional_info_label
import quip.composeapp.generated.resources.brand
import quip.composeapp.generated.resources.category_header
import quip.composeapp.generated.resources.durability_days_label
import quip.composeapp.generated.resources.model
import quip.composeapp.generated.resources.ok
import quip.composeapp.generated.resources.please_complete_all_required_fields
import quip.composeapp.generated.resources.quantity_with_unit
import quip.composeapp.generated.resources.required
import quip.composeapp.generated.resources.spare_part_category_battery
import quip.composeapp.generated.resources.spare_part_category_brakes
import quip.composeapp.generated.resources.spare_part_category_filters
import quip.composeapp.generated.resources.spare_part_category_lights
import quip.composeapp.generated.resources.spare_part_category_oil
import quip.composeapp.generated.resources.spare_part_category_other
import quip.composeapp.generated.resources.spare_part_category_tires
import quip.composeapp.generated.resources.spare_part_type_air_filter
import quip.composeapp.generated.resources.spare_part_type_battery_12v
import quip.composeapp.generated.resources.spare_part_type_brake_discs
import quip.composeapp.generated.resources.spare_part_type_brake_pads_front
import quip.composeapp.generated.resources.spare_part_type_brake_pads_rear
import quip.composeapp.generated.resources.spare_part_type_cabin_filter
import quip.composeapp.generated.resources.spare_part_type_engine_oil
import quip.composeapp.generated.resources.spare_part_type_fuel_filter
import quip.composeapp.generated.resources.spare_part_type_oil_filter
import quip.composeapp.generated.resources.spare_part_type_tire
import quip.composeapp.generated.resources.spare_part_type_tire
import quip.composeapp.generated.resources.spare_part_type_transmission_oil
import quip.composeapp.generated.resources.spare_part_type_brake_fluid
import quip.composeapp.generated.resources.spare_part_type_all_brake_pads
import quip.composeapp.generated.resources.spare_part_type_other
import quip.composeapp.generated.resources.spare_part_type_label
import quip.composeapp.generated.resources.spare_part_autofilled
import quip.composeapp.generated.resources.this_spare_part_type_requires_quantity
import quip.composeapp.generated.resources.reference_optional_label


@Composable
fun getSparePartCategoryString(key: String): String {
    return when (key) {
        "spare_part.category.oil" -> stringResource(Res.string.spare_part_category_oil)
        "spare_part.category.filters" -> stringResource(Res.string.spare_part_category_filters)
        "spare_part.category.brakes" -> stringResource(Res.string.spare_part_category_brakes)
        "spare_part.category.tires" -> stringResource(Res.string.spare_part_category_tires)
        "spare_part.category.battery" -> stringResource(Res.string.spare_part_category_battery)
        "spare_part.category.lights" -> stringResource(Res.string.spare_part_category_lights)
        "spare_part.category.other" -> stringResource(Res.string.spare_part_category_other)
        else -> key
    }
}

@Composable
fun getSparePartTypeString(key: String): String {
    return when (key) {
        "spare_part.type.engine_oil" -> stringResource(Res.string.spare_part_type_engine_oil)
        "spare_part.type.transmission_oil" -> stringResource(Res.string.spare_part_type_transmission_oil)
        "spare_part.type.oil_filter" -> stringResource(Res.string.spare_part_type_oil_filter)
        "spare_part.type.air_filter" -> stringResource(Res.string.spare_part_type_air_filter)
        "spare_part.type.fuel_filter" -> stringResource(Res.string.spare_part_type_fuel_filter)
        "spare_part.type.cabin_filter" -> stringResource(Res.string.spare_part_type_cabin_filter)
        "spare_part.type.brake_pads_front" -> stringResource(Res.string.spare_part_type_brake_pads_front)
        "spare_part.type.brake_pads_rear" -> stringResource(Res.string.spare_part_type_brake_pads_rear)
        "spare_part.type.brake_discs" -> stringResource(Res.string.spare_part_type_brake_discs)
        "spare_part.type.tire" -> stringResource(Res.string.spare_part_type_tire)
        "spare_part.type.battery_12v" -> stringResource(Res.string.spare_part_type_battery_12v)
        "spare_part.type.brake_fluid" -> stringResource(Res.string.spare_part_type_brake_fluid)
        "spare_part.type.all_brake_pads" -> stringResource(Res.string.spare_part_type_all_brake_pads)
        "spare_part.type.other" -> stringResource(Res.string.spare_part_type_other)
        else -> key
    }
}
/**
 * Pantalla para añadir un repuesto a un mantenimiento.
 */
@OptIn(ExperimentalMaterialApi::class)
@Composable
fun AddSparePartScreen(
    catalog: DSparePartCatalog?,
    onAddSparePart: (DSparePart) -> Unit,
    onGetLastSparePart: suspend (categoryId: String, sparePartId: String) -> DSparePart?,
    onNavigateBack: () -> Unit,
    innerPadding: PaddingValues,
    // Autocomplete data
    distinctBrands: List<String> = emptyList(),
    distinctModels: List<String> = emptyList(),
    distinctDurabilityDays: List<Int> = emptyList()
) {
    // Localized strings
    val pleaseCompleteAllRequiredFields = stringResource(Res.string.please_complete_all_required_fields)
    val thisSparePartTypeRequiresQuantity = stringResource(Res.string.this_spare_part_type_requires_quantity)
    val categoryHeader = stringResource(Res.string.category_header)
    val sparePartTypeLabel = stringResource(Res.string.spare_part_type_label)
    val brandLabel = stringResource(Res.string.brand)
    val modelLabel = stringResource(Res.string.model)
    val quantityWithUnit = stringResource(Res.string.quantity_with_unit)
    val durabilityDaysLabel = stringResource(Res.string.durability_days_label)
    val additionalInfoLabel = stringResource(Res.string.additional_info_label)
    val required = stringResource(Res.string.required)
    val ok = stringResource(Res.string.ok)
    val autoFillMessage = stringResource(Res.string.spare_part_autofilled)

    var selectedCategoryId by remember { mutableStateOf<String?>(null) }
    var selectedSparePartTypeId by remember { mutableStateOf<String?>(null) }
    var brand by remember { mutableStateOf("") }
    var model by remember { mutableStateOf("") }
    var additionalInfo by remember { mutableStateOf("") }
    var durabilityDays by remember { mutableStateOf("") }
    var reference by remember { mutableStateOf("") }
    var quantity by remember { mutableStateOf("") }

    var showCategoryMenu by remember { mutableStateOf(false) }
    var showSparePartTypeMenu by remember { mutableStateOf(false) }
    var showSnackbar by remember { mutableStateOf(false) }
    var snackbarMessage by remember { mutableStateOf("") }
    var showAutoFillSnackbar by remember { mutableStateOf(false) }

    // Selected type details
    val selectedSparePartType = remember(selectedSparePartTypeId, catalog) {
        catalog?.sparePartTypes?.get(selectedSparePartTypeId)
    }
    // Filtered types by category
    val filteredSparePartTypes = remember(selectedCategoryId, catalog) {
        selectedCategoryId?.let { catId ->
            catalog?.sparePartTypes?.values?.filter { it.categoryId == catId } ?: emptyList()
        } ?: emptyList()
    }

    // Auto-rellenar campos cuando se seleccione categoría y tipo
    LaunchedEffect(selectedCategoryId, selectedSparePartTypeId) {
        if (selectedCategoryId != null && selectedSparePartTypeId != null) {
            val lastSparePart = onGetLastSparePart(selectedCategoryId!!, selectedSparePartTypeId!!)
            if (lastSparePart != null) {
                brand = lastSparePart.brand
                model = lastSparePart.model
                reference = lastSparePart.reference ?: ""
                // Auto-rellenar cantidad si el tipo actual requiere cantidad
                if (selectedSparePartType?.hasQuantity == true) {
                    quantity = lastSparePart.quantity?.toString() ?: ""
                }
                showAutoFillSnackbar = true
            }
        }
    }

    Scaffold(
        floatingActionButton = {
            FloatingActionButton(
                modifier = Modifier.padding(innerPadding),
                onClick = {
                    // Validar campos obligatorios
                    if (selectedCategoryId == null || selectedSparePartTypeId == null || brand.isBlank() || model.isBlank()) {
                        snackbarMessage = pleaseCompleteAllRequiredFields
                        showSnackbar = true
                        return@FloatingActionButton
                    }
                    if (selectedSparePartType?.hasQuantity == true && quantity.isBlank()) {
                        snackbarMessage = thisSparePartTypeRequiresQuantity
                        showSnackbar = true
                        return@FloatingActionButton
                    }
                    val sparePart = DSparePart(
                        id = null,
                        categoryId = selectedCategoryId!!,
                        sparePartId = selectedSparePartTypeId!!,
                        brand = brand,
                        model = model,
                        additionalInfo = additionalInfo,
                        durabilityDays = durabilityDays.toIntOrNull() ?: 0,
                        quantity = (if (selectedSparePartType?.hasQuantity == true) quantity.toDoubleOrNull() else 1.0) ?: 1.0,
                        unit = selectedSparePartType?.unit ?: QuipConstants.Units.count,
                        reference = reference
                    )
                    onAddSparePart(sparePart)
                    onNavigateBack()
                },
                backgroundColor = QuipColors.colorPrimary,
                contentColor = Color.White
            ) {
                Icon(Icons.Default.Done, contentDescription = "Add Spare Part")
            }
        },
        backgroundColor = QuipColors.colorBackground
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .padding(innerPadding)
                .imePadding()
        ) {
            
            val addSparePartTitle = stringResource(Res.string.add_spare_part)
            // Header
            QuipTransparentHeader {
                Row(verticalAlignment = androidx.compose.ui.Alignment.CenterVertically) {
                    androidx.compose.material.IconButton(onClick = onNavigateBack) {
                        Icon(
                            androidx.compose.material.icons.Icons.Default.ArrowBack,
                            contentDescription = "Back",
                            tint = QuipColors.colorText
                        )
                    }
                    androidx.compose.foundation.layout.Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = addSparePartTitle,
                        style = androidx.compose.material.MaterialTheme.typography.h5,
                        fontWeight = androidx.compose.ui.text.font.FontWeight.Bold,
                        color = QuipColors.colorText
                    )
                }
            }

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 16.dp)
                    .verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
            //Spacer(modifier = Modifier.height(56.dp))

            // Categoría
            // Usamos strings hardcoded porque los recursos no existen
            QuipSectionHeader(title = categoryHeader, icon = Icons.Default.Add)
            ExposedDropdownMenuBox(
                expanded = showCategoryMenu,
                onExpandedChange = { showCategoryMenu = !showCategoryMenu }
            ) {
                QuipTextField(
                    value = selectedCategoryId?.let { getSparePartCategoryString(catalog?.categories?.get(it) ?: "") } ?: "",
                    onValueChange = {},
                    label = categoryHeader,
                    readOnly = true,
                    trailingIcon = {
                        ExposedDropdownMenuDefaults.TrailingIcon(expanded = showCategoryMenu)
                    }
                )
                ExposedDropdownMenu(
                    expanded = showCategoryMenu,
                    onDismissRequest = { showCategoryMenu = false }
                ) {
                    catalog?.categories?.forEach { (id, name) ->
                        DropdownMenuItem(onClick = {
                            selectedCategoryId = id
                            selectedSparePartTypeId = null
                            showCategoryMenu = false
                        }) {
                            Text(getSparePartCategoryString(name))
                        }
                    }
                }
            }

            // Tipo de repuesto
            QuipSectionHeader(title = sparePartTypeLabel, icon = Icons.Default.Add)
            ExposedDropdownMenuBox(
                expanded = showSparePartTypeMenu,
                onExpandedChange = { if (selectedCategoryId != null) showSparePartTypeMenu = !showSparePartTypeMenu }
            ) {
                QuipTextField(
                    value = selectedSparePartTypeId?.let { catalog?.sparePartTypes?.get(it)?.let { type -> getSparePartTypeString(type.translationKey) } } ?: "",
                    onValueChange = {},
                    label = sparePartTypeLabel,
                    readOnly = true,
                    enabled = selectedCategoryId != null,
                    trailingIcon = {
                        ExposedDropdownMenuDefaults.TrailingIcon(expanded = showSparePartTypeMenu)
                    }
                )
                ExposedDropdownMenu(
                    expanded = showSparePartTypeMenu,
                    onDismissRequest = { showSparePartTypeMenu = false }
                ) {
                    filteredSparePartTypes.forEach { type ->
                        DropdownMenuItem(onClick = {
                            selectedSparePartTypeId = type.id
                            showSparePartTypeMenu = false
                        }) {
                            Text(getSparePartTypeString(type.translationKey))
                        }
                    }
                }
            }

            // Campos de texto con autocompletado
            QuipDropdownTextField(
                options = distinctBrands,
                selectedOption = brand.takeIf { it.isNotBlank() && distinctBrands.contains(it) },
                label = brandLabel,
                isFiltrable = true,
                onOptionSelected = { _, option -> brand = option },
                onTextChanged = { brand = it },
                onClearOption = { brand = "" },
                helperText = required
            )
            QuipDropdownTextField(
                options = distinctModels,
                selectedOption = model.takeIf { it.isNotBlank() && distinctModels.contains(it) },
                label = modelLabel,
                isFiltrable = true,
                onOptionSelected = { _, option -> model = option },
                onTextChanged = { model = it },
                onClearOption = { model = "" },
                helperText = required
            )
            if (selectedSparePartType?.hasQuantity == true) {
                QuipTextField(
                    value = quantity,
                    onValueChange = { quantity = it },
                    label = quantityWithUnit.replace("%s", selectedSparePartType.unit ?: ""),
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Decimal,
                        imeAction = ImeAction.Next
                    ),
                    helperText = { Text(required, color = QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
            }
            QuipDropdownTextField(
                options = distinctDurabilityDays.map { it.toString() },
                selectedOption = durabilityDays.takeIf { it.isNotBlank() && distinctDurabilityDays.map { d -> d.toString() }.contains(it) },
                label = durabilityDaysLabel,
                isFiltrable = true,
                onOptionSelected = { _, option -> durabilityDays = option },
                onTextChanged = { durabilityDays = it },
                onClearOption = { durabilityDays = "" }
            )
            QuipTextField(
                value = reference,
                onValueChange = { reference = it },
                label = stringResource(Res.string.reference_optional_label),
                keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
            )
            QuipTextField(
                value = additionalInfo,
                onValueChange = { additionalInfo = it },
                label = additionalInfoLabel,
                keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done),
                minLines = 3
            )

            Spacer(modifier = Modifier.height(80.dp))

            // Snackbar para errores de validación
            if (showSnackbar) {
                Snackbar(
                    action = {
                        TextButton(onClick = { showSnackbar = false }) {
                            Text(ok, color = Color.White)
                        }
                    },
                    modifier = Modifier.padding(16.dp),
                    backgroundColor = QuipColors.colorError
                ) { Text(snackbarMessage) }
            }

            // Snackbar para auto-relleno
            if (showAutoFillSnackbar) {
                Snackbar(
                    action = {
                        TextButton(onClick = { showAutoFillSnackbar = false }) {
                            Text(ok, color = Color.White)
                        }
                    },
                    modifier = Modifier.padding(16.dp),
                    backgroundColor = QuipColors.colorPrimary
                ) { Text(autoFillMessage) }
            }
            }
        }
    }
}
